import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "@connect/i18n";
import { OtpVerification } from "../../components/otp-verification";
export const PhoneOtpScreen = t0 => {
  const $ = _c(11);
  const {
    onContinue
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("onboarding.phoneOtp.title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("onboarding.phoneOtp.codeSent");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-surface-foreground">+1(315)•••876</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <>{t2}{" "}{t3}</>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onContinue || $[8] !== t1 || $[9] !== t4) {
    t5 = <OtpVerification title={t1} subtitle={t4} onContinue={onContinue} />;
    $[7] = onContinue;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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